import { AutogenModelMcUnit, AutogenRowMcUnit } from "./autogen/AutogenModelMcUnit";

export class ModelMcUnit extends AutogenModelMcUnit<RowMcUnit> {
	constructor() {
		super(RowMcUnit);
	}
}

export class RowMcUnit extends AutogenRowMcUnit {
}